<div class="modal-header">
  <h3 class="modal-title">{{ title | translate}}</h3>
  <button type="button" class="close" (click)="closeClick()">
    <span aria-hidden="true">×</span>
  </button>
</div>
<div class="modal-body">
  <app-partner-registration #partnerComponent [partner]="partner"
    [showPassword]="false" [showOldPasswordConfirmation]="false" [showRepeatEmail]="false"
    [showEmailAgree]="false" [showAGBAgree]="false" (eventRegistrationDataValid)="editDataValid()"
    (eventRegistrationDataInvalid)="editDataInvalid()" [title]="" [description]="''"></app-partner-registration>
</div>
<div class="modal-footer">
  <button class="btn btn-primary btn-dialog" (click)="confirmClick()" [disabled]="!confirmButtonEnabled">{{ 'Ok' |
    translate }}</button>
</div>
